export default __webpack_public_path__ + "static/media/delete_icon.f41f4ada.svg";